<template>
  <div class="svg-box">
    <svg width="100%" height="100%" version="1.1">
      <polygon v-for="(item,index) in points" :points="item.ps"
               style="fill:rgba(0,0,255,0.1);stroke:#000000;stroke-width:1"></polygon>
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        _points: [],
      }
    },

    props: ["svgPolygonPoints"],
//    svgPolygonPoints: [
//      {name: '甲板1', points: [{x: 10, y: 10}, {x: 250, y: 10}, {x: 210, y: 210}, {x: 10, y: 210}]},
//      {name: '甲板2', points: [{x: 310, y: 310}, {x: 850, y: 410}, {x: 510, y: 510}, {x: 310, y: 510}]},
//      {name: '甲板3', points: [{x: 810, y: 810}, {x: 1050, y: 810}, {x: 1010, y: 1010}, {x: 810, y: 1010}]}
//    ],

    computed: {},

    created() {
      let svgPolygonPoints = [...this.svgPolygonPoints];
      for (let i = 0; i < svgPolygonPoints.length; i++) {
        let array = [];
        for (let j = 0; j < svgPolygonPoints[i].points.length; j++) {
          array.push(svgPolygonPoints[i].points[j].x + ',' + svgPolygonPoints[i].points[j].y);
        }
        svgPolygonPoints[i].ps = array.join(' ');
      }
      this.points = svgPolygonPoints;
    },

    updated() {
      //console.log(this.points);
      //console.error(11111111111)
    },

    methods: {},

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../common/less/variable.less";

  .svg-box {
    width: 100%;
    height: 100%;
    /*background: red;*/
  }
</style>
